import { combineReducers } from 'redux';
import auth from './auth/authSlice';
import appSettings from './appSettingsSlice';
import cart from './cartSlice';
import restaurant from './restaurantSlice';
import reservation from './reservationSlice';
import customerAuth from './customerAuthSlice';
import onlineOrderingUi from './onlineOrderingUiSlice';
import customerNotification from './customerNotificationSlice';
import loyalty from './loyaltySlice';

const rootReducer = combineReducers({
  auth,
  appSettings,
  cart,
  restaurant,
  reservation,
  customerAuth,
  onlineOrderingUi,
  customerNotification,
  loyalty,
});

export default rootReducer;
